type AutorizaTransitoLancheInput = {
  numeroCartao?: string
  pessoaId?: string
}

type AutorizaTransitoLancheOutput = {
  pessoa: PessoaTransitoLanche
  turno: string
  quantidade_transitos_hoje: number
  quantidade_transitos_turno: number
  data: string
}

export enum TipoConsumo {
  CemPorCentoSubsidiado = 0,
  ParcialmenteSubsidiado = 1
}

export type PessoaTransitoLanche = {
  pessoa_id: number
  nome: string
  nome_social: string
  identificacao: number
  pessoa_tipo: string
  situacao: string
  curso?: string
  categoria: string
}

export type AutorizaTransitoLanche = (
  input: AutorizaTransitoLancheInput
) => Promise<AutorizaTransitoLancheOutput>

type ObterTransitoStatsOutput = {
  turno: string
  quantidade_transitos_hoje: number
  quantidade_transitos_turno: number
  data: string
}

export type ObterTransitoStats = () => Promise<ObterTransitoStatsOutput>

export type RelatorioConsumoLancheItem = {
  id: number | string
  pessoa_id: number | string
  nome: string
  cpf: string
  matricula: string
  curso: string
  turno_curso: string
  tipo_lanche: string
  data_horario_consumo: string
}

type ObterRelatorioConsumoLancheInput = {
  params?: any
}

export type ObterRelatorioConsumoLanche = (
  input?: ObterRelatorioConsumoLancheInput
) => Promise<any>

export type RelatorioConsumoAlmocoItem = {
  nome: string
  matricula: string
  cpf: string
  curso: string
  turno_curso: string
  tipo_consumo: string
  tipo_refeicao: string
  origem_registro: string
  data_horario_consumo: string
}

export type RelatorioConsumoAlmocoPagination = {
  total: number
  total_in_page: number
  current_page: number
  per_page: number
  page_count: number
}

export type RelatorioConsumoAlmocoResponse = {
  items: RelatorioConsumoAlmocoItem[]
  pagination: RelatorioConsumoAlmocoPagination
}

type ObterRelatorioConsumoAlmocoInput = {
  params?: any
}

export type ObterRelatorioConsumoAlmoco = (
  input?: ObterRelatorioConsumoAlmocoInput
) => Promise<RelatorioConsumoAlmocoResponse>

type ExportarRelatorioConsumoLancheInput = {
  params?: any
}

type ExportarRelatorioConsumoLancheOutput = {
  file: File
  headers?: any
}

export type ExportarRelatorioConsumoLanche = (
  input?: ExportarRelatorioConsumoLancheInput
) => Promise<ExportarRelatorioConsumoLancheOutput>
